module.exports = __webpack_public_path__ + "static/media/mshtml_32539.1e0c8229.ico";